export const LOAD_DIMENSIONTYPES = "LOAD_DIMENSIONTYPES";
export const INCOMING_INVOICE_DIMENSIONS = "INCOMING_INVOICE_DIMENSIONS";
export const RECEIPT_DIMENSIONS = "RECEIPT_DIMENSIONS";
export const CASH_RECONCILIATION_DIMENSIONS = "CASH_RECONCILIATION_DIMENSIONS";
export const INVOICE_DIMENSIONS = "INVOICE_DIMENSIONS";
export const ALL_DIMENSIONS = "ALL_DIMENSIONS";
export const INCOMING_INVOICE_DIMENSION_SUGGESTIONS = "INCOMING_INVOICE_DIMENSION_SUGGESTIONS";
export const RECEIPT_DIMENSION_SUGGESTIONS = "RECEIPT_DIMENSION_SUGGESTIONS";
export const INVOICE_DIMENSION_SUGGESTIONS = "INVOICE_DIMENSION_SUGGESTIONS";
export const CASH_RECONCILIATION_DIMENSIONS_SUGGESTIONS = "CASH_RECONCILIATION_DIMENSIONS_SUGGESTIONS";
export const TOGGLE_LANGUAGE = "TOGGLE_LANGUAGE";
export const LOAD_GENERIC_COMMENTS = "LOAD_GENERIC_COMMENTS";
export const CANCEL_REQUEST = "CANCEL_REQUEST";
export const PROFILESETTINGS_LANGUAGE = "PROFILESETTINGS_LANGUAGE";
export const LOAD_SUPPORT_ISSUE_CATEGORIES = "LOAD_SUPPORT_ISSUE_CATEGORIES";
export const SET_COMPANY_ACCOUNTING_DONE_UNTIL = "SET_COMPANY_ACCOUNTING_DONE_UNTIL";
export const SET_COMPANY_LAST_RECONCILIATION = "SET_COMPANY_LAST_RECONCILIATION";
